import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";

type MainTabType = "activities" | "tasks" | "leaves" | "projects" | "reports";
type ManagerDashboardVariant = "manager" | "company-activities";

interface ManagerDashboardHeaderProps {
  variant: ManagerDashboardVariant;
  mainTab: MainTabType;
  onTabChange: (tab: MainTabType) => void;
  showAssignTaskButton?: boolean;
  onAssignTask?: () => void;
}

export const ManagerDashboardHeader: React.FC<ManagerDashboardHeaderProps> = ({
  variant,
  mainTab,
  onTabChange,
  showAssignTaskButton = false,
  onAssignTask,
}) => {
  return (
    <>
      {variant === "manager" && (
        <div className="mb-3 flex flex-col gap-3 lg:grid lg:grid-cols-[1fr_auto_1fr] lg:items-center">
          <div />
          <div className="-mx-3 flex gap-2 overflow-x-auto px-3 pb-1 sm:mx-0 sm:px-0 lg:justify-center lg:gap-3 lg:overflow-visible lg:pb-0">
            <button
              onClick={() => onTabChange("projects")}
              className={`shrink-0 px-4 py-2.5 rounded-xl font-bold text-[14px] transition-all shadow-md sm:px-6 sm:text-[15px] ${
                mainTab === "projects"
                  ? "bg-gradient-to-r from-purple-600 to-pink-600 text-white scale-105"
                  : "bg-white text-gray-600 hover:bg-gray-50"
              }`}
            >
              Projeler
            </button>
            <button
              onClick={() => onTabChange("activities")}
              className={`shrink-0 px-4 py-2.5 rounded-xl font-bold text-[14px] transition-all shadow-md sm:px-6 sm:text-[15px] ${
                mainTab === "activities"
                  ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white scale-105"
                  : "bg-white text-gray-600 hover:bg-gray-50"
              }`}
            >
              Aktiviteler
            </button>
            <button
              onClick={() => onTabChange("tasks")}
              className={`shrink-0 px-4 py-2.5 rounded-xl font-bold text-[14px] transition-all shadow-md sm:px-6 sm:text-[15px] ${
                mainTab === "tasks"
                  ? "bg-gradient-to-r from-cyan-600 to-sky-600 text-white scale-105"
                  : "bg-white text-gray-600 hover:bg-gray-50"
              }`}
            >
              {"Görevler"}
            </button>
            <button
              onClick={() => onTabChange("leaves")}
              className={`shrink-0 px-4 py-2.5 rounded-xl font-bold text-[14px] transition-all shadow-md sm:px-6 sm:text-[15px] ${
                mainTab === "leaves"
                  ? "bg-gradient-to-r from-red-600 to-rose-600 text-white scale-105"
                  : "bg-white text-gray-600 hover:bg-gray-50"
              }`}
            >
              {"İzinler"}
            </button>
            <button
              onClick={() => onTabChange("reports")}
              className={`shrink-0 px-4 py-2.5 rounded-xl font-bold text-[14px] transition-all shadow-md sm:px-6 sm:text-[15px] ${
                mainTab === "reports"
                  ? "bg-gradient-to-r from-green-600 to-emerald-600 text-white scale-105"
                  : "bg-white text-gray-600 hover:bg-gray-50"
              }`}
            >
              Raporlar
            </button>
          </div>
          <div className="flex justify-end">
            {showAssignTaskButton && onAssignTask && (
              <button
                type="button"
                onClick={onAssignTask}
                className="inline-flex h-10 w-full items-center justify-center px-3.5 py-2 text-[13px] font-bold rounded-xl shadow-md border border-transparent text-white bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 whitespace-nowrap sm:w-auto lg:h-9"
                title={"Görev Ata"}
              >
                <PlusIcon className="w-4 h-4 mr-1.5" />
                {"Görev Ata"}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};
